import React from 'react';
import { findLowestPrice } from '../../../helper';

const PriceBanner = ({prices}) => {
    const lowestPrice = findLowestPrice(prices);

    if (!lowestPrice) {
        return null;
    }

    return (
        <li>
            <span className="atbd_meta atbd_listing_average_pricing">
                {lowestPrice}
            </span>
        </li>
    );
};

export default PriceBanner;
